import * as types from './types';

export const setShowError = ({ commit }, payload) => {
  commit(types.SET_SHOW_ERROR, payload);
};
export const setErrorMessage = ({ commit }, payload) => {
  commit(types.SET_ERROR_MESSAGE, payload);
};
export const setErrorTitle = ({ commit }, payload) => {
  commit(types.SET_ERROR_TITLE, payload);
};
export const setRedirectPageOnError = ({ commit }, payload) => {
  commit(types.SET_REDIRECT_PAGE_ON_ERROR, payload);
};
export const setRedirectPageOnErrorMessage = ({ commit }, payload) => {
  commit(types.SET_REDIRECT_PAGE_ON_ERROR_MESSAGE, payload);
};
export const setBlockEmailSubmission = ({ commit }, payload) => {
  commit(types.SET_BLOCK_EMAIL_SUBMISSION, payload);
};

export default {
  setShowError,
  setErrorMessage,
  setErrorTitle,
  setRedirectPageOnError,
  setRedirectPageOnErrorMessage,
  setBlockEmailSubmission
};



// WEBPACK FOOTER //
// ./src/store/modules/errors/actions.js